import { Card, CardContent, Chip, Divider, Paper } from '@material-ui/core';
import { PlayCircleFilled } from '@material-ui/icons';
import React from 'react'
import { Line } from 'react-chartjs-2';
import palette from '../../../../../theme/palette';
import { defaultPaperPadding } from '../../../../../config';

const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    legend: { display: false },
    cornerRadius: 20,
    tooltips: {
        enabled: true,
        mode: 'index',
        intersect: false,
        borderWidth: 1,
        borderColor: palette.divider,
        backgroundColor: palette.white,
        titleFontColor: palette.text.primary,
        bodyFontColor: palette.text.secondary,
        footerFontColor: palette.text.secondary
    },
    layout: { padding: 0 },
    scales: {
        xAxes: [
            {
                barThickness: 12,
                maxBarThickness: 10,
                barPercentage: 0.5,
                categoryPercentage: 0.5,
                ticks: {
                    fontColor: palette.text.secondary
                },
                gridLines: {
                    display: true,
                    drawBorder: true,
                    color: '#c3c3c3',
                    zeroLineColor: '#c3c3c3',
                    drawTicks: false
                }
            }
        ],
        yAxes: [
            {
                ticks: {
                    fontColor: palette.text.secondary,
                    beginAtZero: true,
                    min: 0
                },
                gridLines: {
                    display: false,
                    borderDash: [2],
                    borderDashOffset: [2],
                    color: palette.text.secondary,
                    drawBorder: false,
                    zeroLineBorderDash: [2],
                    zeroLineBorderDashOffset: [2],
                    zeroLineColor: palette.text.secondary
                }
            }
        ]
    }
};

export const PlayGraph = props => {
    const { playsData, currentTotal, oldTotal } = props

    const percent = Math.abs(parseInt(((currentTotal - oldTotal) / (oldTotal > 0 ? oldTotal : 1)) * 100)).toString()

    const labels = [];

    let totalPlays = 0

    playsData.forEach((pd) => {
        const actualDate = new Date(pd.dateAcesso)
        const actualStringLabel = `${actualDate.getDate()}/${actualDate.getMonth() + 1}/${actualDate.getFullYear()}`
        if (labels.find((l) => l == actualStringLabel) == undefined) {
            labels.push(actualStringLabel)
        }

        totalPlays += pd.count
    })

    const data = {
        labels,
        datasets: [
            {
                label: 'Plays',
                pointRadius: 5,
                pointHoverRadius: 7,
                pointBackgroundColor: 'white',
                pointBorderWidth: 3,
                lineTension: 0,
                data: labels.map((l) => {
                    const repOnDay = playsData.filter((reprod) => {
                        const repDate = new Date(reprod.dateAcesso)
                        return `${repDate.getDate()}/${repDate.getMonth() + 1}/${repDate.getFullYear()}` == l
                    })

                    let count = 0
                    repOnDay.forEach((d) => {
                        count += d.count
                    })

                    return count
                }),
                borderColor: palette.primary.main,
                backgroundColor: 'transparent'
            },
        ],
    };
    return <Card style={{ height: '100%', borderRadius: '15px', display: 'flex', flexDirection: 'column', padding: defaultPaperPadding }}>
        <div className={'paperData'}>
            <div style={{ padding: '10px 20px', color: 'grey' }}>
                <h3>Reproduções</h3>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <h1 style={{ padding: '10px 0', marginRight: '5px' }}>{totalPlays}</h1>
                    <h2 style={{ color: percent == 0 ? 'grey' : percent > 0 ? 'green' : 'red' }}>{percent == 0 ? '' : percent > 0 ? '+' : ''}{percent}%</h2>
                </div>
                <h3 style={{ color: 'lightgrey' }}>Número de vezes que seu conteúdo foi reproduzido</h3>
            </div>
        </div>
        <CardContent style={{ height: '100%', width: '100%' }}>
            <div style={{ height: '100%', width: '100%' }}>
                <Line options={options} data={data} />
            </div>
        </CardContent>
    </Card>
}
